import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "../Checkout.page.css";

const STEPS = [
  { number: 1, label: "Carrello" },
  { number: 2, label: "Consegna" },
  { number: 3, label: "Pagamento" },
];

const StepIndicator = ({ currentStep }) => {
  return (
    <div className="co-stepper">
      {STEPS.map((step, index) => {
        const isCompleted = currentStep > step.number;
        const isActive = currentStep === step.number;

        return (
          <React.Fragment key={step.number}>
            <div
              className={`co-stepper__step${
                isCompleted
                  ? " co-stepper__step--completed"
                  : isActive
                  ? " co-stepper__step--active"
                  : ""
              }`}
            >
              <div className="co-stepper__circle">
                {isCompleted ? (
                  <FontAwesomeIcon icon={faCheck} />
                ) : (
                  step.number
                )}
              </div>
              <span className="co-stepper__label">{step.label}</span>
            </div>
            {index < STEPS.length - 1 && (
              <div
                className={`co-stepper__line${
                  isCompleted ? " co-stepper__line--completed" : ""
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
